import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';

// eslint-disable-next-line import/prefer-default-export
export const CanvasStyled = styled.div`
  max-width: ${rem(2000)};
  margin: 0 auto;
  overflow-x: hidden;
`;
